import React from "react";
import i18next from "i18next";
import { withTranslation } from "react-i18next";
import { FormGroup, FormControl, FormLabel, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import { companyService } from "services";

import Layout from "components/Layout";
import Loading from "components/Loading";
import * as companyActions from "actions/companyActions";


class MyCompany extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
			company: {},
			errors: {},
			user: this.props.user,
		};
	}

	async componentDidMount() {
		const companyId = this.props.user.company.id;
		await this.props.getCompany(companyId);
		await this.props.getCountries();

		this.setState({
			company: this.props.company,
		});
	}

	handleChange = (event) => {
		const { company } = this.state;
		this.setState({
			company: {
				...company,
				[event.target.id]: event.target.value,
			},
		});
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		const { company } = this.state;
		const response = await companyService.update(company);

		if (!response.ok) {
			this.setState({
				submitted: true,
				isLoading: false,
				errors: errorFormating(response),
			});
		} else {
			toastr.success(i18next.t("common.success"), i18next.t("common.changesSaved"));

			this.setState({
				submitted: false,
				isLoading: false,
				errors: {},
			});
		}
	};

	getContent() {
		const { t } = this.props;
		const { company } = this.state;
		const { countries } = this.props;

		if (this.props.loading || Object.keys(company).length <= 0) {
			return <Loading />;
		}

		const optionList =
			countries.length > 0 &&
			countries.map((item, i) => (
				<option key={i} value={item.iso}>
					{item.name}
				</option>
			));

		return (
			<form className="form-company" onSubmit={this.handleSubmit}>
				<Row>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="name">
							<FormLabel>
								{t("myCompany.labelName")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={company.name}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelName")}
								isInvalid={this.checkValidField("name")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.name}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="vat_number">
							<FormLabel>
								{t("myCompany.labelVat")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={company.vat_number}
								onChange={this.handleChange}
								placeholder={t("myCompany.placeholderVat")}
								isInvalid={this.checkValidField("vat_number")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.vat_number}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
				</Row>
				<Row>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="address">
							<FormLabel>
								{t("myCompany.labelAddress")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={company.address}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelAddress")}
								isInvalid={this.checkValidField("address")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.address}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="postal_code">
							<FormLabel>
								{t("myCompany.labelPostalCode")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={company.postal_code}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelPostalCode")}
								isInvalid={this.checkValidField("postal_code")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.postal_code}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="city">
							<FormLabel>
								{t("myCompany.labelCity")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={company.city}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelCity")}
								isInvalid={this.checkValidField("city")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.city}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="province">
							<FormLabel>
								{t("myCompany.labelProvince")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={company.province}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelProvince")}
								isInvalid={this.checkValidField("province")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.province}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="country_iso">
							<FormLabel>
								{t("myCompany.labelCountry")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								onChange={this.handleChange}
								value={company.country_iso}
								isInvalid={this.checkValidField("country_iso")}
								as="select"
							>
								<option value="-1">{t("myCompany.selectCountry")}</option>
								{optionList}
							</FormControl>
							<FormControl.Feedback type="invalid">
								{this.state.errors.country_iso}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="email">
							<FormLabel>
								{t("myCompany.labelEmail")} <span className="label-required">*</span>
							</FormLabel>
							<FormControl
								type="text"
								value={company.email}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelEmail")}
								isInvalid={this.checkValidField("email")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.email}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="web">
							<FormLabel>{t("myCompany.labelWeb")}</FormLabel>
							<FormControl
								type="text"
								value={company.web}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelWeb")}
								isInvalid={this.checkValidField("web")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.web}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
					<Col sm={6} md={4}>
						<FormGroup className="form-group" controlId="phone">
							<FormLabel>{t("myCompany.labelPhone")}</FormLabel>
							<FormControl
								type="text"
								value={company.phone}
								onChange={this.handleChange}
								placeholder={t("myCompany.labelPhone")}
								isInvalid={this.checkValidField("phone")}
							/>
							<FormControl.Feedback type="invalid">
								{this.state.errors.phone}
							</FormControl.Feedback>
						</FormGroup>
					</Col>
				</Row>

				<SubmitButton
					type="submit"
					isLoading={this.state.isLoading}
					text={t("myCompany.btnSave")}
					loadingText={t("common.saving")}
				/>
			</form>
		);
	}

	render() {
		const { t } = this.props;
		return (
			<Layout className="page-company">
					<div className="heading">
						<h1 className="title">{t("myCompany.title")}</h1>
					</div>
				<div className="page-container container">

					<div className="page-content">{this.getContent()}</div>
				</div>
			</Layout>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.companyReducer,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getCompany: (company_id) => dispatch(companyActions.getCompany(company_id)),
	getCountries: () => dispatch(companyActions.getCountries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MyCompany));
